import {Storage} from 'aws-amplify';

export async function getAdminReports(entityId,entityType,districtId){
  const options = {
    bucket: process.env.REPORTS_BUCKET,
    contentType: 'text/csv',
    level: "public",
    customPrefix: {
      public: "",
    },
  };

  let returnValue = await Storage.list('v2/'+entityType+'/'+districtId+'/'+entityId,options)
  .then(async (result) => {
    let reports = await Promise.all(result.map(async (item)=>{
      let reportURL = await Storage.get(item.key, {
        bucket: process.env.REPORTS_BUCKET,
        download: false,
        contentType: 'text/csv',
        level: "public",
        customPrefix: {
          public: "",
        }
      });

      let window = item.key && item.key.split("-")[1]
      return ({
        status: reportURL,
        createdAt: new Date(item.lastModified),
        entityId: entityId,
        entityType: entityType,
        window: window
      });
    }));

    return Promise.resolve(reports);
  })
  .catch((err) => {
    console.log(err);
    return Promise.resolve(null);
  });
  return returnValue;
}
